class FooterEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // const footerNoInfo = document.querySelector(".js-no-footer-info")

    // if(footerNoInfo){

    //   const footerInfo = document.querySelector(".js-l-footer__info")
    //   footerInfo.classList.add("is-hidden")

    // }

    const footerNoLine = document.querySelector(".js-no-footer-line")

    if(footerNoLine){
      const footer = document.querySelector(".js-footer")
      footer.classList.add("is-noLine")
    }

    const footerNoEntry = document.querySelector(".js-no-footer-entry")

    if(footerNoEntry){
      const footerEntry = document.querySelector(".info-entry")

      if(footerEntry){
        footerEntry.classList.add("is-hidden")
      }
    }

  }
}
